<template>
  <v-footer
    color="blue-grey darken-1"
    padless
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-btn
        v-for="link in links"
        :key="link.link"
        color="white"
        text
        rounded
        class="my-2"
        :to="link.link"
      >
        {{ link.title }}
      </v-btn>
      <v-col
        class="blue-grey darken-2 py-4 text-center white--text"
        cols="12"
      >
        {{ new Date().getFullYear() }} — <strong>zrshishir@gmail.com</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
  export default {
    data: () => ({
      links: [
        {link: '/', title:'About'},
        {link: '/skill', title:'Skills'},
        {link: '/project', title:'Projects'},
        {link: '/experience', title:'Experience'}
      ],
    }),
  }
</script>